module.exports = __webpack_public_path__ + "img/deposit2.71a16fcd.jpg";